import Immutable from 'immutable';

const SatisfactionForm = Immutable.Record({
  id: null,
  scaleLabelHigh: null,
  scaleLabelLow: null,
  scaleType: null,
  scaleOptions: null,
  ratingPrompt: null,
  questions: [],
});

export default SatisfactionForm;
